export default ({ request }) => ({
  mrpPurchaseStockInListApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/stockIn/list',
      method: 'post',
      data,
    })
  },
  mrpPurchaseStockInDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/stockIn/detail',
      method: 'post',
      data,
    })
  },
  mrpPurchaseStockInSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/stockIn/save',
      method: 'post',
      data,
    })
  },
  mrpPurchaseStockInDelApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/stockIn/del',
      method: 'post',
      data,
    })
  },
  mrpPurchaseStockInSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/purchase/stockIn/submit',
      method: 'post',
      data,
    })
  },
})
